import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

/**
 * Get responsible data by login.
 *
 * @param {string} login - The login of the responsible.
 * @returns {Promise<Object>} A Promise that resolves with the responsible data.
 */
export function getResponsibleByLogin(login) {
  return axios.get(`${apiUrl}/autofill/responsible/${login}`);
}

/**
 * Get profile data by login.
 *
 * @param {string} login - The login of the profile.
 * @returns {Promise<Object>} A Promise that resolves with the profile data.
 */
export function getProfileByLogin(login) {
  return axios.get(`${apiUrl}/autofill/profile/${login}`);
}
